<div class="weather-container">
  <div class="clock">{{time.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})}}</div>
  <div class="local-date">{{time.toLocaleDateString('en-us', {
    weekday: "long",
    day: 'numeric',
    month: "long",
    year: 'numeric'
  })}}</div>
</div>
